export default {
  updateUserAuth(state, value) {
    if (value) {
      state.userAuth = true;
    }
  },

  updateUserInfoAgree(state) {
    state.userInfo.need_agree = false;
  },

  updateUserInfo(state, value) {
    state.userInfo = value;
    if (value?.dealer?.units) {
      state.userInfo.dealer.units = state.units.find(item => item.value === state.userInfo.dealer.units);
    }
  },

  updateConfig(state, data) {
    state.config = data;
    if (data.hide) {
      state.config.hide_blocks.top_menu = false;
      state.config.hide_blocks.calculation = false;
      state.config.hide_blocks.basket = false;
      state.config.hide_blocks.price.widget = false;
      state.config.hide_blocks.price.zgi = false;
      state.config.hide_blocks.price.cut = false;
      state.config.hide_blocks.price.opt = false;
    }
  },

  updateUserInfoNotifications(state) {
    state.userInfo.unviewed_count--;
  },

  incrementNotification(state) {
    state.userInfo.unviewed_count++;
  },

  updateUserInfoDealer(state, data) {
    if (data.units) {
      state.userInfo.dealer.units = data.units;
    } else if (data.currency) {
      state.userInfo.dealer.currency.id = data.currency.id;
      state.userInfo.dealer.currency.fix_rate_only = data.currency.fix_rate_only;
      state.userInfo.dealer.currency.label = data.currency.label;
      state.userInfo.dealer.currency.symbol = data.currency.symbol;
    } else {
      state.userInfo.dealer[data.type] = data.data[data.type];
    }
  },

  updateCurrencies(state, data) {
    state.currencies = data;
  },

  userInfoProductionUpdate(state, value) {
    state.userInfo.dealer.has_production = value;
  },

  userInfoWarehouseUpdate(state, value) {
    state.userInfo.dealer.has_warehouse = value;
  },

  userInfoMaxZgiUpdate(state, val) {
    state.userInfo.dealer.max_zgi_count = val;
  },

  userInfoMaxCutUpdate(state, val) {
    state.userInfo.dealer.max_cut_count = val;
  },

  updateCompanies(state, data) {
    state.companies = data;
  },

  addCompany(state, newCompany) {
    state.companies.push(newCompany)
  },

  updateConfigAccess(state, data) {
    state.configAccess = data;
  },

  removeCompany(state, index) {
    state.companies.splice(index, 1);
  },

  changeCompany(state, val) {
    state.companies.splice(val.index, 0);
    state.companies[val.index] = val.data;
  },

  changeDefaultOrganization(state, {id, is_default}) {
    const companies = state.companies
    if (!companies || !companies.length) return;

    state.companies = companies.map(o => {
      if (is_default === 1) {
        o.is_default = (o.id !== id) ? 0 : 1
      }
      return o
    })
  },

  updateBuildNumber(state, data) {
    state.build.number = data;
  },

  updateBuildReload(state, val) {
    state.build.reload = val;
  },
}
